import { ServiceChargeConfig } from '../core/api/store/store.types';

export interface None {
  status: 'none';
}

export interface Loading {
  status: 'loading';
  config: ServiceChargeConfig;
}

export interface Valid {
  status: 'valid';
  config: ServiceChargeConfig;
}

export const Default: None = {
  status: 'none',
};

export type States = None | Loading | Valid;
